import { render, staticRenderFns } from "./TaskNPS.vue?vue&type=template&id=bbd49fa4&scoped=true&"
import script from "./TaskNPS.vue?vue&type=script&lang=js&"
export * from "./TaskNPS.vue?vue&type=script&lang=js&"
import style0 from "./TaskNPS.vue?vue&type=style&index=0&id=bbd49fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd49fa4",
  null
  
)

export default component.exports